module.exports = __webpack_public_path__ + "static/media/other-dialog-avator.482045f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/dialog/other-dialog-avator.png
// module id = 413
// module chunks = 1